import { ScorecardsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function ScorecardFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <ScorecardsCommandList multiselect selected={selection} onSelect={onSelect} />
}
